import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { Providers } from "./providers";
import ErrorBoundary from "../components/ErrorBoundary";

export function App() {
  return (
    <ErrorBoundary>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </ErrorBoundary>
  );
}
